module.exports = __webpack_public_path__ + "akne_4_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/akne_4_after.jpg
// module id = 921
// module chunks = 0